(function oneTrustCookies() {
  /** @param {MouseEvent} e */
  function toggleOneTrustCookies(e) {
    // Toggle OneTrust preference center if available
    // @ts-ignore - OneTrust is injected by the OneTrust script
    window.OneTrust?.ToggleInfoDisplay?.();
  }

  function bind() {
    document
      .querySelectorAll('a[href="#onetrust-preferences"]')
      .forEach((link) => {
        if (!(link instanceof Element)) return;
        if (link.getAttribute("data-onetrust-bound") === "true") return;
        link.setAttribute("data-onetrust-bound", "true");
        link.addEventListener("click", toggleOneTrustCookies);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind, { once: true });
  } else {
    bind();
  }
})();
